import { render, staticRenderFns } from "./contentUserViewActivity.vue?vue&type=template&id=b5bc6536&"
import script from "./contentUserViewActivity.vue?vue&type=script&lang=js&"
export * from "./contentUserViewActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports